import { initMobileNav } from "./nav";

(function () {
  "use strict";

  initMobileNav({ headerId: "app-header", toggleSelector: "#app-nav-toggle", linksId: "app-nav-links", backdropId: "app-nav-backdrop" });

  // User dropdown (details/summary) — sync aria-expanded and close on outside click
  var userDropdown = document.getElementById("user-dropdown");

  document.addEventListener("click", function (e) {
    if (userDropdown && userDropdown.open && !userDropdown.contains(e.target)) {
      userDropdown.removeAttribute("open");
    }
  });

  if (userDropdown) {
    var summary = userDropdown.querySelector(".user-dropdown-trigger");

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && userDropdown.open) {
        userDropdown.removeAttribute("open");
        if (summary) {
          summary.focus();
        }
      }
    });

    var observer = new MutationObserver(function () {
      if (summary) summary.setAttribute("aria-expanded", userDropdown.open ? "true" : "false");
    });
    observer.observe(userDropdown, { attributes: true, attributeFilter: ["open"] });
    if (summary) summary.setAttribute("aria-expanded", userDropdown.open ? "true" : "false");
  }
})();
